import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog, MatSort, PageEvent } from '@angular/material';
import { AddDriverComponent } from './add-driver/add-driver.component';
import { HttpService } from '../http.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { EventService } from '../event.service';
import { AttachVehicleComponent } from '../attach-vehicle/attach-vehicle.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { Messages } from '../constants/messages';
import { MapModalComponent } from '../map-modal/map-modal.component';
import { DriverPathComponent } from '../driver-path/driver-path.component';
import { SnackbarService } from '../snackbar.service';
import { BulkUploadComponent } from '../bulk-upload/bulk-upload.component';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ViewDriverComponent } from './view-driver/view-driver.component';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ValidationService } from '../validation.service';
import { AddAttendanceComponent } from './add-attendance/add-attendance.component';
import { HolidaysListComponent } from './holidays-list/holidays-list.component';
import { BulkUploadVehicleComponent } from '../bulk-upload-vehicle/bulk-upload-vehicle.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface Drivers {
  _id: string;
  driverName: string;
  driverMobile: string;
  profilePic: string;
  currentlocation: object;
  residentId: string;
  driver_type: string;
}

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.scss']
})
export class DriversComponent implements OnInit {

  video_URL_OWN_FLEET = this.sanitizer.bypassSecurityTrustResourceUrl(environment.ADDING_OWN_DRIVER);
  video_ATTACH_VEHICLE_DRIVER = this.sanitizer.bypassSecurityTrustResourceUrl(environment.ATTACH_VEHICLE);
  video_DETACH_VEHICLE = this.sanitizer.bypassSecurityTrustResourceUrl(environment.DETACH_VEHICLE);
  driverDownloadSample = environment.DRIVER_BULK_UPLOAD_SAMPLE;
  showLoader = false;
  showButtons = false;
  dialogData: any = {};

  columnsToDisplay = ['selected', 'driverName', 'app_status', 'driverMobile', 'driver_type', 'licence_number', 'vehicle_info', 'shipment_info', 'action'];//battery_status
  driverArray: any = [];
  totalDrivers = 0;
  drivers: any = [];
  selectedDriversArray: any = [];
  selectedDriver: any = {};
  disableButton = false;
  smartphoneRef: any;
  changePwdRef: any;
  markOnOffDutyRef: any;
  optInData: any;
  optInRef;
  VideoLinkRef: any;
  MultipleVideoLinkRef: any;
  driversList: MatTableDataSource<Drivers>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('optIn', { static: true }) optIn: TemplateRef<any>;
  @ViewChild('smartPhone', { static: true }) smartPhone: TemplateRef<any>;
  @ViewChild('changePwd', { static: true }) changePwd: TemplateRef<any>;
  @ViewChild('markOnOff', { static: true }) markOnOff: TemplateRef<any>;
  @ViewChild('uploadDialog', { static: true }) uploadDialog: TemplateRef<any>;
  @ViewChild("ownFleetDriver", { static: true }) ownFleetDriver: TemplateRef<any>;
  // @ViewChild("SpotDriver", { static: true }) SpotDriver: TemplateRef<any>;
  @ViewChild("attachVehicleToDriver", { static: true }) attachVehicleToDriver: TemplateRef<any>;
  @ViewChild("detachVehicle", { static: true }) detachVehicle: TemplateRef<any>;
  @ViewChild("MultipleVideoOptions", { static: true }) MultipleVideoOptions: TemplateRef<any>;

  trackingTypes = [{
    name: 'SIM Based Tracking',
    checked: 'false'
  }, {
    name: 'APP Based Tracking',
    checked: 'false'
  }, {
    name: 'GPS Based Tracking',
    checked: 'false'
  }];

  mark_off_duty_comment = '';
  leave_types = [
    { name: 'Paid Leave', value: 'paid_leave' },
    { name: 'Absent', value: 'absent' },
    { name: 'Holiday', value: 'holiday' },
  ];
  selectedLeaveType: any;

  driverTypes = [
    {
      name: 'All',
      val: ''
    },
    {
      name: 'Contracted',
      val: 'contracted'
    },
    {
      name: 'Aggregated',
      val: 'aggregated'
    },
    {
      name: 'Own',
      val: 'own'
    }
  ];

  driverFilters: any = {};
  filters: any = {
    name: '',
    mobile: '',
    licence: '',
    driver_type: '',
  };
  filterValue = '';
  shipStatus = [
    {
      name: 'PNDG',
      value: 'Pending'
    }, {
      name: 'ALC',
      value: 'Allocated'
    }, {
      name: 'ACPT',
      value: 'Accepted'
    }, {
      name: 'ASN',
      value: 'Assigned'
    }, {
      name: 'ITNS',
      value: 'In Transit'
    }, {
      name: 'CPTD',
      value: 'Completed'
    }, {
      name: 'SP',
      value: 'Towards Pickup'
    }, {
      name: 'AP',
      value: 'At Pickup'
    }, {
      name: 'ALD',
      value: 'At Delivery'
    }, {
      name: 'CNCL',
      value: 'Cancelled'
    }, {
      name: 'ABTR',
      value: 'About to Reach'
    }
  ];

  shipperUpdates: Subscription;
  errors = new Messages();
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];

  subscription: Subscription;
  searchTextChanged = new Subject<object>();
  uploadDocsRef: any;
  fileLength = 0;
  driverId = '';
  regFormData = new FormData();

  constructor(private dialog: MatDialog, private http: HttpService, private storage: StorageService, private route: Router,
    private events: EventService, private snackBar: SnackbarService, private translation: TranslateService,
    private changeDetection: ChangeDetectorRef, private valid: ValidationService, private sanitizer: DomSanitizer
  ) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');

    }
  }


  ngOnInit() {
    this.getAllDrivers();
    this.shipperUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getAllDrivers();
      }
    );
  }

  ngOnDestroy() {
    this.shipperUpdates.unsubscribe();
  }

  openDriverMapView() {
    this.route.navigateByUrl('driver-map-view');
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.removeFocus();
      this.getAllDrivers(x);
    });
    this.changeDetection.detectChanges();
  }

  getAllDrivers(filter: any = {}) {
    this.showLoader = true;
    if (!filter.driver_type) {
      delete filter.driver_type;
    }
    filter.limit = this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);

    this.http.get('driver/get_all', filter, 3).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode == 200) {
          this.driverArray = data.data.drivers;
          this.totalDrivers = data.data.count;
          this.drivers = [];
          const driverType = {
            contracted: 'Contracted',
            aggregated: 'Aggregated',
            own: 'Own'
          };
          this.driverArray.forEach((element, index) => {
            const temp: any = {
              currentlocation: []
            };

            temp._id = element._id;
            temp.index = index + 1;
            temp.driverName = element.name;
            temp.driverMobile = element.mobile;
            temp.os_version = element.os_version;
            temp.ram = element.ram;
            temp.model = element.model;
            temp.SecondaryMobile = element.mobile2;
            temp.app_version = element.app_version ? element.app_version : 'N/A'
            temp.attached = element.attached_driver ? true : false;
            temp.attached_driver_data = element.attached_driver ? element.attached_driver : '';
            if (temp.attached_driver_data) {
              temp.vehicle_no = temp.attached_driver_data.vehicle_no;
              temp.vehicle_name = temp.attached_driver_data.vehicle_type.name;
              temp.battery_status = temp.attached_driver_data.battery_status ? temp.attached_driver_data.battery_status + '%' : '--';
              temp.last_online_time = temp.attached_driver_data.last_online_time;
              let last = this.diff_minutes(new Date(), new Date(temp.last_online_time));
              if (last <= 20) {
                temp.status = 'Online'
              } else {
                temp.status = 'Offline'
              }
              if (temp.attached_driver_data.assigned_shipment) {
                if (temp.attached_driver_data.assigned_shipment) {
                  temp.shipment_status = this.shipStatus.find(item => item.name == temp.attached_driver_data.assigned_shipment.latest_status).value;
                  temp.shipment_id = temp.attached_driver_data.assigned_shipment.SIN;
                } else {
                  temp.shipment_status = '';
                  temp.shipment_id = '';
                }
              } else if (temp.attached_driver_data.shipment) {
                if (temp.attached_driver_data.shipment) {
                  temp.shipment_status = this.shipStatus.find(item => item.name == temp.attached_driver_data.shipment.latest_status).value;
                  temp.shipment_id = temp.attached_driver_data.shipment.SIN;
                } else {
                  temp.shipment_status = '';
                  temp.shipment_id = '';
                }
              } else {
                temp.shipment_status = '';
                temp.shipment_id = '';
              }

              if (temp.attached_driver_data.geo_point) {
                temp.current_location = {
                  longitude: temp.attached_driver_data.geo_point.coordinates[0],
                  latitude: temp.attached_driver_data.geo_point.coordinates[1]
                }
              }
            } else {
              temp.vehicle_no = '--';
              temp.vehicle_name = '--';
              temp.status = 'Offline';
            }
            temp.driver_status = element.latest_attendance.status;
            if (temp.driver_status) {
              temp.trip_status = "On Duty"
            } else {
              temp.trip_status = "Off Duty"
            }
            temp.profilePic = element.profile_pic ? element.profile_pic.original : 'assets/1_Driver-Icon-Big.svg';
            if (element.geo_point) {
              temp.currentlocation.push(element.geo_point.coordinates[0]);
              temp.currentlocation.push(element.geo_point.coordinates[1]);
            }

            temp.residentId = element.residentId || 'N/A';
            temp.driver_type = (element.driver_type == 'contracted') ? driverType.contracted : ((element.driver_type == 'aggregated') ? driverType.aggregated : ((element.driver_type == 'own') ? driverType.own : 'N/A'));
            temp.licence = element.licence;
            temp.home_location = element.home_location;
            temp.city = element.city;
            temp.ws_opt_in = element.ws_opt_in;
            temp.has_smart_phone = element.has_smart_phone ? true : false;
            this.drivers.push(temp);
          });
          if (!this.driversList) {
            this.driversList = new MatTableDataSource(this.drivers);
            this.driversList.sort = this.sort;
            this.driversList.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label');
          } else {
            this.driversList = new MatTableDataSource(this.drivers);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label');
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label');
        console.log('Err-=', err);
      }
    );
  }

  pageNavigate(event: PageEvent) {
    this.driverFilters.limit = event.pageSize;
    this.driverFilters.skip = event.pageIndex * event.pageSize;
    this.selectedDriversArray = [];
    this.showButtons = false;
    this.getAllDrivers(this.driverFilters);
  }

  selectDriverType(track, event) {
    if (event.source._selected) {
      this.driverFilters.driver_type = track.val;
      if (!this.driverFilters.driver_type) {
        delete this.driverFilters.driver_type;
      }
      this.getAllDrivers(this.driverFilters);
    }
  }
  diff_minutes(dt2, dt1) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  searchFilter(value, type) {
    this.changeDetection.detectChanges();
    if (value.length) {
      switch (type) {
        case 'name':
          this.driverFilters.name = value;
          break;
        case 'mobile':
          this.driverFilters.mobile = value;
          break;
        case 'licence':
          this.driverFilters.licence_no = value;
          break;
      }
      this.reSubscribe();
      this.searchTextChanged.next(this.driverFilters);
    } else {
      this.clearFilter(type);
    }
  }

  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }

  clearFilter(type) {
    switch (type) {
      case 'name':
        delete this.driverFilters.name;
        break;
      case 'mobile':
        delete this.driverFilters.mobile;
        break;
      case 'licence':
        delete this.driverFilters.licence_no;
        break;
      case 'type':
        delete this.driverFilters.driver_type;
        break;
    }
    this.getAllDrivers(this.driverFilters);
  }

  openBulkUpload() {
    const dialogData: any = {
      sampleURL: this.driverDownloadSample,
      heading: this.translation.instant('BULKUPLOAD.uploadFile'),
      fileHeading: this.translation.instant('BULKUPLOAD.uploadFile'),
      uploadURL: 'driver/bulk_upload',
      type: 'driver'
    };
    const dialogRef = this.dialog.open(BulkUploadVehicleComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getAllDrivers();
      }
    });
  }

  applyFilter(value: string) {
    this.filterValue = value;
    this.driversList.filter = this.filterValue.trim().toLowerCase();
  }
  clear() {
    this.driverFilters = {};
    this.filters = {
      name: '',
      mobile: '',
      licence: '',
      driver_type: ''
    };
    this.getAllDrivers(this.driverFilters);
  }

  openAddDriver(heading = 'ADD', driver: any = '') {
    const data: any = {
      header: heading
    };
    if (driver) {
      data.driverData = driver;
    }
    const dialogRef = this.dialog.open(AddDriverComponent, {
      data: data,
      width: '1250px',
      maxWidth: '95vw !important'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getAllDrivers();
      }
    });
  }

  openAttachVehicle(data, type) {
    if (type == 'Attach') {
      const dialogRef = this.dialog.open(AttachVehicleComponent, {
        data: data
      });
      dialogRef.afterClosed().subscribe(result => {
        if ((result && result.statusCode == 200) || result == 'yes') {
          this.getAllDrivers();
        }
      });
    } else if (type == 'Detach') {
      const dialogData = {
        name: 'Detach Vehicle',
        text: this.errors.DRIVERS.DIALOGDATA.DETACHVEHICLE,
        driver_id: data.attached_driver_data._id,
        url: 'driver/detach'
      }
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(result => {
        if ((result && result.statusCode == 200) || result == 'yes') {
          this.getAllDrivers();
        }
      });
    }
  }

  openMapView() {
    this.route.navigateByUrl('driver-map-view')
  }
  // openMap(element) {
  //   const mapData: any = {
  //     driverLoc: element.currentlocation,
  //     justMarker: true
  //   };
  //   const dialogRef = this.dialog.open(DriverMapComponent, {
  //     data: mapData,
  //   });
  // }
  openDriverPath(element) {
    this.dialog.open(DriverPathComponent, {
      data: element,
      width: '1250px',
      maxWidth: '95vw !important'
    });
  }

  //view driver details
  openViewDriver(driver) {
    const dialogRef = this.dialog.open(ViewDriverComponent, {
      data: driver,
    });
  }

  whatsapp() {
    this.showLoader = true;
    const dataa = {
      driver: this.optInData._id
    };
    this.http.post('driver/ws_opt_in', dataa).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.snackBar.openSnackBar(this.errors.DRIVERS.DIALOGDATA.OPTIN, '');
          this.optInRef.close();
          this.getAllDrivers();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  optInWa(element) {
    this.optInData = element;
    this.optInRef = this.dialog.open(this.optIn);
  }

  smartphoneDialog(element) {
    this.smartphoneRef = this.dialog.open(this.smartPhone);
  }

  selectLeaveType(type) {
    this.selectedLeaveType = type;
  }

  selectDriver(event: any, driver: any) {
    if (event.checked && this.selectedDriversArray.indexOf(driver._id) == -1) {
      this.selectedDriversArray.push(driver._id);
    } else if (this.selectedDriversArray.indexOf(driver._id) > -1) {
      this.selectedDriversArray.splice(this.selectedDriversArray.indexOf(driver._id), 1);
    }
    (this.selectedDriversArray.length) ? this.showButtons = true : this.showButtons = false;
  }

  markSelected(flag = true) {
    const dataToSend = {
      driver_ids: this.selectedDriversArray,
      has_smart_phone: flag
    };
    this.showLoader = true;
    this.http.post('driver/markSmartPhone', dataToSend).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode == 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.MARK_SMARTPHONE.SUCCESS'), '');
          this.smartphoneRef.close();
          this.getAllDrivers(this.driverFilters);
          this.selectedDriversArray = [];
          this.showButtons = false;
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  openChangePwd(element) {
    this.selectedDriver = element;
    this.selectedDriver.newPassword = '';
    this.selectedDriver.confirmPassword = '';
    this.changePwdRef = this.dialog.open(this.changePwd);
  }

  changePassword() {
    if (this.valid.isEmpty(this.selectedDriver.newPassword) || this.valid.isEmpty(this.selectedDriver.confirmPassword)) {
      this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.VALIDATION.FILL_ALL'), '', 'err');
      return;
    } else {
      if (!this.valid.isPassword(this.selectedDriver.newPassword) || !this.valid.isPassword(this.selectedDriver.confirmPassword)) {
        this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.VALIDATION.PASSWORD_LENGTH'), '', 'err');
        return;
      } else if (this.selectedDriver.newPassword !== this.selectedDriver.confirmPassword) {
        this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.VALIDATION.PASSWORD_MATCH'), '', 'err');
        return;
      }
    }

    this.showLoader = true;
    this.disableButton = true;
    const dataToSend: any = {
      driver_id: this.selectedDriver._id,
      password: this.selectedDriver.newPassword
    };
    this.http.post('driver/change_password', dataToSend).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.showLoader = false;
          this.disableButton = false;
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.CHANGE_PASSWORD.SUCCESS'), '');
          this.changePwdRef.close();
          this.getAllDrivers();
        }
      },
      (err: any) => {
        this.disableButton = false;
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  fileChanged(event: any) {
    if (event.target.files.length && (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png')) {
      this.fileLength = event.target.files.length;
      for (let x = 0; x < this.fileLength; x++) {
        this.regFormData.append('profile_pic', event.target.files[x]);
      }
    } else {
      this.snackBar.openSnackBar(this.translation.instant('DRIVERS.image'), '', 'err');
      this.regFormData.delete('profile_pic');
    }
  }
  openUploadDialog(element) {
    this.regFormData = new FormData();
    this.driverId = element._id;
    this.uploadDocsRef = this.dialog.open(this.uploadDialog);
    this.uploadDocsRef.afterClosed().subscribe((data) => {
      if (data && data.statusCode == 200) {
        this.getAllDrivers();
      }
    })
  }
  uploadRegDocs(element) {
    if (this.fileLength > 0) {
      this.showLoader = true;
      this.http.upload('v2/driver/upload/' + this.driverId, this.regFormData).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.showLoader = false;
            this.snackBar.openSnackBar(this.translation.instant('DRIVERS.docsUpload'), '');
            this.driverId = '';
            this.fileLength = 0;
            this.uploadDocsRef.close(data);
            this.regFormData = new FormData();
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackBar.openSnackBar(err.error.message, '', 'err');
          this.regFormData = new FormData();
        }
      );
    } else {
      this.snackBar.openSnackBar(this.translation.instant('DRIVERS.image'), '', 'err');
    }
  }

  markOffDuty(element) {
    this.dialogData.markOff = element.driver_status ? true : false;
    this.dialogData.name = element.driver_status ? 'Mark Off Duty' : 'Mark On Duty';
    this.dialogData.text = element.driver_status ? this.translation.instant('MESSAGE.DRIVERS.DIALOGDATA.MARK_OFF_DUTY') : this.translation.instant('MESSAGE.DRIVERS.DIALOGDATA.MARK_ON_DUTY');
    this.dialogData.driver = element._id;

    this.markOnOffDutyRef = this.dialog.open(this.markOnOff);
    this.markOnOffDutyRef.afterClosed().subscribe(result => {
      if ((result && result.statusCode == 200) || result == 'yes') {
        this.getAllDrivers();
      }
    });
  }

  submitMarkOnOff() {
    let payload: any = {};
    if (this.dialogData.markOff) {
      payload = {
        driver: this.dialogData.driver,
        comment: this.dialogData.comment,
        status: this.selectedLeaveType.value
      }
      this.dialogData.url = 'driver/mark_off_duty';

      if (!payload.status) {
        this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.VALIDATION.LEAVE_TYPE'), '', 'err');
        return;
      } else if (!payload.comment) {
        this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.VALIDATION.COMMENT'), '', 'err');
        return;
      }
    } else {
      payload = {
        driver: this.dialogData.driver,
        comment: this.dialogData.comment
      }
      if (!payload.comment) {
        delete payload.comment;
      }
      this.dialogData.url = 'driver/mark_on_duty';
    }

    this.showLoader = true;
    this.http.post(this.dialogData.url, payload, 3).subscribe((response: any) => {
      this.showLoader = false;
      if (response.statusCode == 200) {
        if (this.dialogData.markOff) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.SUCCESS.MARK_OFF_DUTY'));
        } else {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.SUCCESS.MARK_ON_DUTY'));
        }
        this.closeModal(response);
      }
    },
      (err) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      })
  }

  closeModal(data: any = {}) {
    if (data && data.statusCode == 200) {
      this.dialogData = {};
      this.selectedLeaveType = ''
      this.markOnOffDutyRef.close();
      this.getAllDrivers();
    } else {
      this.dialogData = {};
      this.selectedLeaveType = ''
      this.markOnOffDutyRef.close();
    }
  }

  openHolidayList() {
    const dialogRef = this.dialog.open(HolidaysListComponent);
  }

  addAttendanceDetails(element) {
    const dialogRef = this.dialog.open(AddAttendanceComponent, {
      data: element
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getAllDrivers();
      }
    });
  }
  openOwnFleetDriverLink() {
    this.VideoLinkRef = this.dialog.open(this.ownFleetDriver, {

    });
  }
  // openSpotDriverVideoLink() {

  //   this.VideoLinkRef = this.dialog.open(this.SpotDriver, {

  //   });
  // }
  attachVehicleToDriverVideoLink() {
    this.VideoLinkRef = this.dialog.open(this.attachVehicleToDriver, {

    });
  }
  detachVehicleVideoLink() {
    this.VideoLinkRef = this.dialog.open(this.detachVehicle, {

    });
  }

  MultipleVideoLink() {

    this.MultipleVideoLinkRef = this.dialog.open(this.MultipleVideoOptions, {

    });
  }

}
